'use strict';

const {isPageType, pageTypes: {PAGE_TYPE: {PDP}}} = require('dibs-buyer-layout/src/entries/index');
const referrerHelpers = require('../../tracking/referrerHelpers');

const fetchPinterestSocialAccounts = require('../queries/fetchPinterestSocialAccounts');
const pinterestUtils = require('../../utils/social/pinterest');
const pdpActionsConstants = require('../../../newPdp/actions/pdpActionsConstants');

const pinterestConnectAccountsModalRule = payload => {
    const { context } = payload;

    if (!isPageType(PDP) || !referrerHelpers.isPinterestReferrer()) {
        return Promise.resolve({ success: false });
    }

    return fetchPinterestSocialAccounts().then(({ socialNetwork, userSocialNetwork }) => {
        const canShowPromotion = pinterestUtils.canShowConnectAccountPromotion({
            socialNetwork,
            userSocialNetwork,
        });
        if (canShowPromotion) {
            context.dispatch(pdpActionsConstants.ACTION_SHOW_PINTEREST_MODAL);
            return {
                success: true,
                type: 'pinterestReferrer',
            };
        }

        return { success: false };
    });
};

module.exports = pinterestConnectAccountsModalRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/pinterestConnectAccountsModalRule.es.js